import { Component } from '@angular/core';

import { IonicPage, NavController, NavParams,ActionSheetController,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { GenericFormValidationProvider } from '../../providers/common/form-validation';

/**
 * Generated class for the EmiempirelateddetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-emiempirelateddetails',
  templateUrl: 'emiempirelateddetails.html',
})
export class EmiempirelateddetailsPage {

  arrReason:any=[];
  communicationEmail:any="";
   
  errorDisplay:any={};
  listCategotyComplains:any=[];
  listSubCategotyComplains:any=[];
  category:any="";
  subcomplain:any="";
  ccs_remarks:any="";
  reason:any="";
  form_date:any;
  to_date:any;
  contactDtailsData:any;
  constructor(
    private loadingCtrl:LoadingController,
    public actionSheetCtrl: ActionSheetController,private fv:GenericFormValidationProvider, public navCtrl: NavController, public navParams: NavParams,private cp:CommonProvider) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad ForseclousrestatementsPage');
    this.contactDtailsData = this.navParams.data.addressDetail.responseParameters.filter((res:any)=>{
      return res.mailingaddress=="Y" && res.addresstype== "CURRES" && res.applicanttype=='Applicant'
    })[0];
    this.communicationEmail = this.contactDtailsData.emailid
     
  }

  
  presentActionSheet(msg) {
    const actionSheet = this.actionSheetCtrl.create({
      title: msg,
      cssClass: 'commanSheet',
      buttons: [
        {
          text: "OK",
          role: 'Ok',
          handler: () => {
             actionSheet.dismiss();
          }
        }
      ]
    });
    actionSheet.present();
  }
  postFormForValidation(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
  
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
    //console.log(this.errorDisplay)
    if(this.errorDisplay.valid){
     return false;
   }else{
    loading.present();
    var ccs_casecategory="CC02";;
    var ccs_casetype="CT22";
    var ibhfl_loanaccountnumber1=localStorage.getItem('cc');
    var ccs_originatingsource="S011"
    var ccs_casesubtype = "ST109";
    var ccs_remarks = this.ccs_remarks;

 


    this.cp.postBounceMemo(loading,ccs_casecategory,ccs_remarks,
                           JSON.parse(localStorage.getItem("existingLoan"))[0].customercode,ccs_casetype,
                           ibhfl_loanaccountnumber1,
                           ccs_originatingsource,
                           ccs_casesubtype,this.form_date,this.to_date).then((res:any)=>{
                            loading.dismiss();
                            var res=JSON.parse(res)
                            this.presentActionSheet("Your SRno. "+res.Payload.caseid+" has been resolved.")
                           })
   
   }
   }


}



// WEBPACK FOOTER //
// ./src/pages/emiempirelateddetails/emiempirelateddetails.ts